import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { GeneralAttachmentsData } from '../../../models/GeneralAttachmentsData';
import { GeneralAttachmentsDataFilter } from '../../../models/GeneralAttachmentsDataFilter';
import { ComplaintsTicktsService } from '../../../services/complaintsTickts.service';

@Component({
  selector: 'app-complaint-attachments',
  templateUrl: './complaint-attachments.component.html',
  standalone: false
})
export class ComplaintAttachmentsComponent implements OnInit {
  @Input({ required: true }) ticketId!: number;
  dataLoading = false;
  isSubmited = false;
  loading = false;
  pageNumber = 1;
  pageSize = 6;
  pageCount = 0;

  recordsData: GeneralAttachmentsData = new GeneralAttachmentsData();
  filterModel: GeneralAttachmentsDataFilter = new GeneralAttachmentsDataFilter();

  //files
  allowedExt = ['pdf', 'docx', 'doc', 'ppt', 'png', 'jpg', 'jpeg', 'mp4', 'pptx'];
  files: any[] = [];

  constructor(
    private service: ComplaintsTicktsService,
    private swalService: SwalService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  getAll(event: any = null) {
    this.dataLoading = true;
    if (event) {
      this.pageNumber = 1;
    }
    this.filterModel.ticketId = this.ticketId;
    this.filterModel.pageSize = this.pageSize;
    this.filterModel.pageNumber = this.pageNumber;
    this.service.getGeneralAttachments(this.filterModel).subscribe(
      (data: GeneralAttachmentsData) => {
        this.dataLoading = false;
        if (data) {
          this.recordsData.totalCount = data.totalCount;
          if (this.recordsData && this.recordsData.data?.length && !event) {
            this.recordsData.data = this.recordsData.data.concat(data.data);
          } else {
            this.recordsData = data as GeneralAttachmentsData;
          }
          this.pageCount = Math.ceil(
            data.totalCount / this.filterModel.pageSize
          );
        }
      },
      (error: any) => {
        this.recordsData = new GeneralAttachmentsData();
        this.dataLoading = false;
      });
  }

  getNextPage() {
    if (this.pageNumber <= this.pageCount - 1) {
      this.pageNumber += 1;
      this.getAll(null);
    }
  }

  saveRecord() {
    this.isSubmited = true;
    if (this.files.length) {
      this.loading = true;
      const formData = new FormData();
      this.files.forEach(file => {
        formData.append(`files`, file, file.name);
      });
      this.service.uploadAttachments(formData, this.ticketId).subscribe(
        (res) => {
          if (res.type === HttpEventType.UploadProgress) {
            // this.progress = Math.round((100 * res.loaded) / res.total);
          } else if (res instanceof HttpResponse) {
            let data: any = res.body;
            // resolve(data.fileUrl);
            // this.progress = 0;
            this.loading = false;
            // this.swalService.swalSuccess('Saved Successfully');
            Swal.fire({
              title: this.translate.instant('swalMsg.savedsuccessfully'),
              imageUrl: './assets/images/icons/success.svg',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
            this.files = [];
            this.isSubmited = false;
            this.getAll(true);
          }
        },
        (error: any) => {
          this.loading = false;
          this.handleErrors(error.detail);
        }
      );
    }
  }

  deletedFiles(e: any) {
    console.log(e);
    this.dataLoading = true;
    this.service.removeAttachment(e[0]).subscribe(
      (data: any) => {
        if (data) {
          Swal.fire({
            title: this.translate.instant('swalMsg.Success'),
            text: this.translate.instant('swalMsg.deletededsuccessfuly'),
            imageUrl: './assets/images/icons/success.svg',
            confirmButtonText: this.translate.instant('swalMsg.Ok')
          });
          this.getAll(true)
        }
      },
      (error: any) => {
        this.dataLoading = false;
      });
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }

}
